import React, { createContext, useContext } from "react";

const HotelContext = createContext(null);

export const useHotelContext = () => {
  const context = useContext(HotelContext);
  return context;
};

export const HotelProvider = HotelContext.Provider;

export default HotelContext;
